<template>
    <v-main class="tw-h-screen tw-p-0">
        <!--Desktop-->
        <div v-if="!isMobile" class="tw-h-full">
            <div class="tw-flex tw-h-full">
                <div class="image-container">
                    <v-img
                        cover
                        height="100%"
                        src="/images/Auth/banner.png"></v-img>
                </div>
                <div class="form-container">
                    <div class="form-wrapper">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
        <!--Mobile-->
        <div v-else class="tw-flex-col tw-h-full">
            <v-sheet
                rounded="t-2xl"
                class="flex-grow-1 tw-h-full">
                <router-view></router-view>
            </v-sheet>
        </div>
    </v-main>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { useDisplay } from 'vuetify';

    const { lgAndUp } = useDisplay();

    const isMobile = computed(() => {
        return !lgAndUp.value;
    });
</script>

<style scoped>
    .img-container {
        height: 22vh;
    }
    .image-container {
        width: 65%;
        min-height: 100vh;
        flex-shrink: 0;
    }
    .form-container {
        width: 35%;
        min-height: 100vh;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .form-wrapper {
        width: 100%;
        max-height: 100vh;
        overflow-y: auto;
        padding: 2rem;
    }
</style>
